import React from "react";
import { Modal } from "@mui/material";
import moment from "moment";

import Icon from "../../../assets/checked.svg";
import "../../DoctorDashboard/component-styles.scss";
import { CONSULTATIONTYPE } from "../../DashboardAppointmentsView/Constant";

export default function ScheduledAppntModal(props) {
  const {
    currentAppointment,
    appointment_start_time,
    patient_name,
    openView,
    startConsultationApi,
    joinVideoCallback,
    closeView,
  } = props;

  function handleYesClick() {
    if (currentAppointment.appointment_type === CONSULTATIONTYPE.INCLINIC) {
      startConsultationApi(currentAppointment);
    } else {
      joinVideoCallback();
    }
    closeView();
  }
  return (
    <>
      {openView ? (
        <Modal
          open={openView}
          onClose={closeView}
        >
         <div className="d-flex justify-content-center align-items-center h-100">
          <div className="appointment-Scheduled-modal-wrapper p-3 p-lg-5">
            <div className="d-flex flex-column justify-content-center align-items-center px-3 px-lg-5">
              <img src={Icon} alt="success" />
              <h4 className="text-center mt-3">Appointment Scheduled </h4>
              <p className="text-center my-2">
                You already have an appointment scheduled at{" "}
                {moment(appointment_start_time, "hh:mm:ssZ").format("hh:mm A")}
                &nbsp;with Patient {patient_name}.
              </p>
              <p className="text-center my-2 font-weight-bold">
                Do you still want to continue?
              </p>
              <div className="d-flex flex-row justify-content-center my-3">
                <button
                  className="btn primary-cta-button rounded-pill px-5 mr-2"
                  onClick={handleYesClick}
                >
                  Yes
                </button>
                <button
                  className="btn secondary-button rounded-pill px-5"
                  onClick={closeView}
                >
                  No
                </button>
              </div>
            </div>
          </div>
         </div>
        </Modal>
      ) : null}
    </>
  );
}
